module.exports = new __parcel__URL__("tag-not-found.0230d293.html").toString();